import { calculateBmi } from '../../../common/utils/bmi';
import { ReadOnlyInputText } from './common';

export function BmiText(props: { length: number | null; weight: number | null }) {
    return (
        <ReadOnlyInputText
            placeholder="BMI"
            value={calculateBmi(props.weight, props.length)}
        />
    );
}
